import { AppSocialMediaLinks } from '@flipdish/api-client-typescript/private/api';
import { makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Form, FormikProps, withFormik } from 'formik';
import React from 'react';
import { Translate } from 'react-localize-redux';
import PaperContainer from '../../../ui/Layout/PaperContainer';
import LoadingButton from '../../../ui/LoadingButton';
import SocialMediaFields from './Fields/SocialMediaFields';

export type FormValues = ReturnType<typeof getDefaultFormState>;
export const getDefaultFormState = (socialMediaLinks: AppSocialMediaLinks) => {
  return {
    FacebookUrl: socialMediaLinks.FacebookUrl || '',
    FourSquareUrl: socialMediaLinks.FourSquareUrl || '',
    InstagramUrl: socialMediaLinks.InstagramUrl || '',
    PintrestUrl: socialMediaLinks.PintrestUrl || '',
    TripAdvisorUrl: socialMediaLinks.TripAdvisorUrl || '',
    TwitterUrl: socialMediaLinks.TwitterUrl || '',
    YelpUrl: socialMediaLinks.YelpUrl || '',
  };
};

type InnerProps = {};
type OuterProps = {
  socialMediaLinks: AppSocialMediaLinks;
  submit: (socialMediaLinks: AppSocialMediaLinks) => Promise<void>;
};
type Props = InnerProps & OuterProps;

const useStyles = makeStyles({
  container: {
    paddingTop: 30,
    paddingRight: 0,
    paddingBottom: 24,
    paddingLeft: 24,
    marginBottom: 30,
  },
  formHeaderContainer: {
    marginBottom: 10,
    borderBottom: '1px solid rgba(0,0,0,0.2)',
  },
  formHeader: {
    paddingTop: 16,
    paddingBottom: 18,
  },
  field: {
    paddingBottom: 16,
    marginTop: 30,
  },
});

const SocialMediaForm = ({ isSubmitting, handleSubmit }: Props & FormikProps<FormValues>) => {
  const classes = useStyles();

  return (
    <Form>
      <PaperContainer fluid>
        <Grid container className={classes.container}>
          <Grid item xs={12} className={classes.formHeaderContainer}>
            <Typography variant="h5" className={classes.formHeader}>
              <Translate id="Social_links" />
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption">
              <Translate id="Social_links_description" />
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.field}>
            <SocialMediaFields />
          </Grid>
          <Grid container justify="flex-end" alignContent="center" spacing={2}>
            <Grid item>
              <LoadingButton
                fdkey="SocialMediaForm_btn"
                color="primary"
                variant="contained"
                loading={isSubmitting}
                onClick={handleSubmit}
                style={{ marginTop: 16, marginRight: 16 }}
              >
                <Translate id="Save" />
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </PaperContainer>
    </Form>
  );
};

export default withFormik<Props, FormValues>({
  displayName: 'SocialMediaForm',
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return getDefaultFormState(props.socialMediaLinks);
  },
  handleSubmit: (values, formikBag) => {
    formikBag.props.submit(values).then(() => {
      formikBag.setSubmitting(false);
    });
  },
})(SocialMediaForm);
